import { render } from "./InputNumberWithButton.vue?vue&type=template&id=5f567930"
import script from "./InputNumberWithButton.vue?vue&type=script&lang=js"
export * from "./InputNumberWithButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__